import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { ApiAuthorizationModule } from '../api-authorization/api-authorization.module';
import { AuthorizeInterceptor } from '../api-authorization/authorize.interceptor';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { ConfirmProcessModalComponent } from './common/components/confirm-process-modal/confirm-process-modal.component';
import { ConfirmProcessDateModalComponent } from './common/components/confirm-process-date-modal/confirm-process-date-modal.component';
import { ListItemSelectorComponent } from './common/components/list-item-selector/list-item-selector.component';
import { ListItemSelectorModalComponent } from './common/components/list-item-selector-modal/list-item-selector-modal.component';
//import { OperativeTrainingRecordsComponent } from './training-records/operative-training-records/operative-training-records.component';
//import { OperativeTrainingRecordComponent } from './training-records/operative-training-record/operative-training-record.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OperativesModule } from './operatives/operatives.module';
import { AppRoutingModule } from './app-routing.module';
import { CompanyService } from './company/services/company.service';
import { CompanyDocumentService } from './company/services/company-documents.service';
import { CompanyModule } from './company/company.module';
import { DocumentTypeService } from './services/document-type.service';
import { CommonsModule } from './common/commons.module';
import { DocumentsModule } from './documents/documents.module';
import { ObservationsService } from './observations/services/observations.service';
import { DocumentService } from './documents/services/document.service';
import { DocumentModalService } from './documents/services/document-modal.service';
import { OperativeDocumentService } from './operatives/services/operative-document.service';
import { SharedModule } from './shared/shared.module';
import { TrainingRecordDocumentService } from './training-records/services/training-record-document.service';
import { MainShellComponent } from './main-shell/main-shell.component';
import { EcaBreadcrumbModule } from './eca-breadcrumb/eca-breadcrumb.module';
import { DatePipe } from '@angular/common';
import { AlertsModule } from './alerts/alerts.module';
import { BugLoggerModule } from './bug-logger/bug-logger.module';
import { HelpPageComponent } from './help/pages/help-page/help-page.component';
import { HelpModule } from './help/help.module';
import { CompanyOptInService } from './company/services/company-opt-in.service';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { DialogService } from "primeng/dynamicdialog";
import { MenubarModule } from 'primeng/menubar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { QuillModule } from 'ngx-quill';
import { NgxPrintModule } from 'ngx-print';
import { CheckboxModule } from 'primeng/checkbox';
import { RiskHelpComponent } from './admin-lists/components/risk-help/risk-help.component';
import { RiskMatrixComponent } from './admin-lists/components/risk-matrix/risk-matrix.component';
import { CompanyTrainingCoursesComponent } from './admin-lists/components/company-training-courses/company-training-courses.component';
import { TrainingCourseEditorComponent } from './admin-lists/training-course-editor/training-course-editor.component';
import { TrainingCourseDetailsComponent } from './admin-lists/components/company-training-course-details/company-training-course-details.component';
import { HttpCancelService } from './common/services/http-cancel.service';
import { HttpCancelInterceptor } from './common/services/cancel-interceptor.service';
import { PanelModule } from 'primeng/panel';
import { AuditHistoryComponent } from './admin-lists/components/audit-history/audit-history.component';
import { TrainingRecordsModule } from './training-records/training-records.module';
import { ObservationDocumentService } from './observations/services/observation-document.service';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    ConfirmProcessModalComponent,
    ConfirmProcessDateModalComponent,
    ListItemSelectorComponent,
    ListItemSelectorModalComponent,
    //OperativeTrainingRecordsComponent,
    //OperativeTrainingRecordComponent,
    MainShellComponent,
    HelpPageComponent,
    RiskHelpComponent,
    RiskMatrixComponent,
    CompanyTrainingCoursesComponent,
    TrainingCourseEditorComponent,
    TrainingCourseDetailsComponent,
    AuditHistoryComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ApiAuthorizationModule,
    QuillModule.forRoot(),
    NgxPrintModule,
    FontAwesomeModule,

    // primeng
    TableModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    CheckboxModule,
    PanelModule,
    TabViewModule,
    MenubarModule,
    BreadcrumbModule,

    // our modules
    EcaBreadcrumbModule,
    AlertsModule,
    BugLoggerModule,
    HelpModule,
    CompanyModule,
    CommonsModule,
    DocumentsModule,
    SharedModule,
    OperativesModule,
    AppRoutingModule,
    TrainingRecordsModule
  ],
  providers: [
    DatePipe,
    CompanyDocumentService,
    ObservationsService,
    CompanyService,
    DocumentTypeService,
    DocumentService,
    DocumentModalService,
    OperativeDocumentService,
    ObservationDocumentService,
    TrainingRecordDocumentService,
    CompanyOptInService,
    HttpCancelService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCancelInterceptor
    },
    DialogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components
    library.addIconPacks(far, fad, fas);
  }
}

export function getWindow() {
  return window;
}
